import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';
import ScrollRevealSection from './components/ScrollRevealSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import TermsAndConditionsPage from "./components/TermsAndConditionsPage";
import AccountDeletionPage from './components/AccountDeletionPage';
import BetaHeroSection from "./components/BetaHeroSection";
import FixedHeader from './components/FixedHeader';
import './styles/fonts.css';
import BetaUserFormNoCaptcha from "./components/BetaUserFormNoCaptcha";
import HeroSection from "./components/HeroSection";
import AprilFoolsDay from "./components/AprilFoolsDay";

const TrackPageView = () => {
    const location = useLocation();

    useEffect(() => {
        const pagePath = location.pathname + location.search;
        window.gtag('config', 'G-D57KTT0CPY', {
            page_path: pagePath,
        });
    }, [location]);

    return null;
};

const App = () => {
    const [xpPoints, setXpPoints] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const scrollHeight = document.documentElement.scrollHeight;
            const clientHeight = window.innerHeight;
            const scrollPercent = scrollTop / (scrollHeight - clientHeight);
            setXpPoints(Math.floor(scrollPercent * 1000));
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <Router>
            <TrackPageView />
            <div className="flex flex-col min-h-screen">
                <FixedHeader xpPoints={xpPoints} />
                <main>
                    <Routes>
                        <Route path="/" element={
                            <>
                                <HeroSection />
                                {/*<BetaHeroSection />*/}
                                <ScrollRevealSection />
                                <FeaturesSection />
                                {/*<CTASection />*/}
                                {/*<LegalLinksSection />*/}
                            </>
                        } />
                        <Route path="/privacy" element={<PrivacyPolicyPage />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                        <Route path="/terms-of-service" element={<TermsAndConditionsPage />} />
                        <Route path="/delete-account" element={<AccountDeletionPage />} />
                        <Route path="/beta" element={<BetaUserFormNoCaptcha/>} />
                    </Routes>
                </main>
                <Footer />
            </div>
        </Router>
    );
};

export default App;